import React from "react";
import styled from "styled-components";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import book from "@fortawesome/fontawesome-free-solid/faBook";
import map from "@fortawesome/fontawesome-free-solid/faMapMarkerAlt";
import player from "@fortawesome/fontawesome-free-solid/faPlay";
import comment from "@fortawesome/fontawesome-free-solid/faComment";

class Blurb extends React.Component {
  render() {
    return (
      <Wrap
        href={this.props.link ? this.props.link : "#"}
        align={this.props.align}
      >
        <Icon color={this.props.color} align={this.props.align}>
          {!this.props.title & !this.props.icon ? ">" : false}
          {this.props.title ? this.props.title : false}
          {this.props.icon === "book" ? <FontAwesomeIcon icon={book} /> : false}
          {this.props.icon === "map" ? <FontAwesomeIcon icon={map} /> : false}
          {this.props.icon === "player" ? (
            <FontAwesomeIcon icon={player} />
          ) : (
            false
          )}
          {this.props.icon === "comment" ? (
            <FontAwesomeIcon icon={comment} />
          ) : (
            false
          )}
        </Icon>
        <span>{this.props.children}</span>
      </Wrap>
    );
  }
}

const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  text-align: center;
  font-weight: 600;
  display: ${props => (props.align === "left" ? "inline-block" : "")};
  font-size: ${props => (props.align === "left" ? "" : "32px")};
  margin: ${props => (props.align === "left" ? "0 16px 0 0" : "0 auto 16px")};
  min-width: ${props => (props.align === "left" ? "32px" : "96px")};
  height: ${props => (props.align === "left" ? "32px" : "96px")};
  line-height: ${props => (props.align === "left" ? "32px" : "96px")};
  background: ${props => (props.color ? props.color : "#ccc")};
  color: ${props =>
    props.color === "#f7e64e"
      ? "rgba(0,0,0,.7)"
      : props.color === "#cddc39"
        ? "rgba(0,0,0,.7)"
        : "rgba(255, 255, 255, 1)"};

  @media (max-width: 960px) {
    display: inline-block;
    font-size: inherit;
    margin: 0 16px 0 0;
    min-width: 32px;
    height: 32px;
    line-height: 32px;
  }
`;

const Wrap = styled.a`
  border: 0;
  text-align: ${props => (props.align === "left" ? "left" : "center")};
  text-decoration: none;
  display: flex;
  flex-direction: ${props => (props.align === "left" ? "row" : "column")};
  align-items: center;
  margin-bottom: 8px;
  @media (max-width: 960px) {
    text-align: left;
    flex-direction: row;
  }

  span {
    white-space: nowrap;
    color: #2b56c1;
    border-bottom: 1px solid #c6d3f2;
    font-size: 16px;
  }

  &:hover {
    span {
      border-color: #2b56c1;
    }
    ${Icon} {
      box-shadow: 0 0 0 5px #c6d3f2;
    }
  }
`;
export default Blurb;



// WEBPACK FOOTER //
// ./src/UI/Media/Blurb.js